export function getAll(fetch, filtros) {
  return fetch().post("/movimentacao/getdet", filtros);
}

export function getCaixaById(fetch, id) {
  return fetch().post(`/caixa/get/${id}`);
}